const api = "https://waterlink-test.utah.gov/";

export const appConfig = {
    env: "at",
    bucketName: "deq-waterlink-at",
    gqlLink: `${api}/graphql`,
    lslLink: `${api}/lsl`,
    authEndpoint: `${api}/auth`,
    authParams: `?paramkey=%2Fdeq%2Fwaterlink_v2_login`,
    revoke: `${api}/auth/revoke`,
    s3FileDownload: `${api}/s3/file-download`,
    s3FileUpload: `${api}/s3/file-upload`,
    s3GetPresignedUrl: `${api}/s3/get-presigned-url`,
    s3PutPresignedUrl: `${api}/s3/put-presigned-url`,
    s3FileCopy: `${api}/s3/file-copy`,
    s3FileDelete: `${api}/s3/file-delete`,
    wlv1_prefix: "/v1/",
    pdfGeneratorUrl: `${api}/pdf/generate-from-url`
};
